import { api } from "../middlewares";

async function marcarNotificacaoFinanceiroComoLida(endPoint, dados) {
  await api.patch(`Notificacao/${endPoint}`, {}, { params: dados });
}

async function marcarDestaqueLido(Id) {
  try {
    await api.patch(
      "Notificacao/MarcarNotificacaoDestaques",
      {},
      {
        params: { Id },
      }
    );
  } catch (error) {
    return [];
  }
}

async function marcarNoticiaLido(Id) {
  try {
    await api.patch(
      "Notificacao/MarcarNotificacaoNoticias",
      {},
      {
        params: { Id },
      }
    );
  } catch (error) {
    return [];
  }
}

async function marcarVideosLido(Id) {
  try {
    await api.patch(
      "Notificacao/MarcarNotificacaoVideos",
      {},
      {
        params: { Id },
      }
    );
  } catch (error) {
    return [];
  }
}

async function marcarFaseLido(IdSalesForce) {
  try {
    await api.patch(
      "Notificacao/MarcarNotificacaoSolicitacaoFase",
      {},
      {
        params: { IdSalesForce },
      }
    );
  } catch (error) {
    return [];
  }
}

async function marcarNotificacaoAgendamento(IdSalesforce) {
  try {
    await api.patch(
      "Notificacao/MarcarNotificacaoSolicitacaoAgendamento",
      {},
      {
        params: { IdSalesforce },
      }
    );
  } catch (error) {
    return [];
  }
}

async function marcarFotoLido(Id) {
  try {
    await api.patch(
      "Notificacao/MarcarNotificacaoAtualizacaoFotos",
      {},
      {
        params: { Id },
      }
    );
  } catch (error) {
    return [];
  }
}

async function marcarNotificacaoVistoriaNaoCompareceu(IdSalesforce) {
  try {
    await api.patch(
      "Notificacao/MarcarNotificacaoVistoriaNaoCompareceu",
      {},
      {
        params: { IdSalesforce },
      }
    );
  } catch (error) {
    return [];
  }
}

async function marcarNotificacaoAniversario(IdAniversario) {
  try {
    await api.patch(
      "Notificacao/MarcarNotificacaoAniversario",
      {},
      {
        params: { IdAniversario },
      }
    );
  } catch (error) {
    return [];
  }
}

async function marcarNotificacaoManutencaoPeriodica(
  IdNotificacaoManutencaoPeriodica
) {
  try {
    await api.patch(
      "Notificacao/MarcarNotificacaoManutencaoPeriodica",
      {},
      {
        params: { IdNotificacaoManutencaoPeriodica },
      }
    );
  } catch (error) {
    return [];
  }
}

async function marcarNotificacoesComoExibidas(ids) {
  console.log("FN marcarNotificacoesComoExibidas", ids);
  try {
    await api.patch("Notificacao/MarcarExibidoAll", {
      ...ids,
    });
    // console.log([...ids]);
  } catch (error) {
    console.error(error);
    return [];
  }
}

// Thiago
async function marcarNotificacaoPesquisaComoRespondida(idSalesForce) {
  try {
    await api.patch(
      `Notificacao/MarcarNotificacaoSolicitacaoConcluida?IdSalesForce=${idSalesForce}`
    );
  } catch (error) {
    return [];
  }
}

async function marcarNotificacaoContratoFinanciamentoLida(idNotificacao) {
  try {
    await api.patch(
      `Notificacao/MarcarNotificacaoContratoFinanciamento?IdNotificacao=${idNotificacao}`
    );
  } catch (error) {
    return [];
  }
}

export {
  marcarDestaqueLido,
  marcarNoticiaLido,
  marcarVideosLido,
  marcarFaseLido,
  marcarFotoLido,
  marcarNotificacoesComoExibidas,
  marcarNotificacaoFinanceiroComoLida,
  marcarNotificacaoAgendamento,
  marcarNotificacaoVistoriaNaoCompareceu,
  marcarNotificacaoAniversario,
  marcarNotificacaoManutencaoPeriodica,
  marcarNotificacaoPesquisaComoRespondida, // Thiago
  marcarNotificacaoContratoFinanciamentoLida,
};
